import { Directive, HostListener, inject } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ selector: "[stagesValidateOnBlur]" })
export class ValidateOnBlurDirective {
	formControl = inject(NgControl);

	@HostListener("focus") onFocus(): void {
		if (this.formControl.control) {
			this.formControl.control.markAsUntouched();
		}
	}

	@HostListener("blur") onBlur(): void {
		if (this.formControl.control) {
			this.formControl.control.markAsTouched();
		}
	}
}
